var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYantroppernewOptimized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "katman_2",
    "data-name": "katman 2",
    viewBox: "0 0 26.67 9.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.66,0h-14.48s.02,9.67.02,9.67h14.48s-.02-9.67-.02-9.67ZM13.79,1.63h1.61v1.61h-1.61v-1.61ZM13.79,8.06v-3.22h1.61v3.22h-1.61ZM23.45,8.05v-1.61h-3.22v1.61h-1.61v-1.61h1.61v-3.22h-1.61v1.61h-1.61V1.61h3.22v1.61h1.61v1.61h1.61V1.61h1.61v3.22h-1.61v1.61h1.61v1.61h-1.62Z",
    fill: "#1e1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19,4.86c0-1.82-1.46-3.3-3.29-3.31s-3.31,1.46-3.31,3.29,1.46,3.3,3.29,3.31,3.31-1.46,3.31-3.29",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33,3.17c0-.24-.2-.44-.43-.44s-.43.2-.44.43c0,.24.19.44.43.44s.44-.2.44-.43",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55,6.69s.22-1.22.34-1.21c.11,0,.32,1.22.32,1.22.03.14.09.25.25.25.17,0,.26-.12.25-.24v-.02l-.24-1.36-.04-.34c0-.05-.03-.22,0-.3,0-.02.03-.05.11-.08l.73-.23c.12-.04.25-.11.25-.25s-.1-.28-.25-.25l-.06.02c-.2.05-.83.23-1.29.22-.49,0-1.19-.2-1.33-.24h-.02c-.14-.05-.25.1-.25.24,0,.14.12.2.25.25h.02l.69.25c.09.03.13.07.13.08,0,0,.04.08,0,.28l-.04.34-.26,1.34v.03c-.02.13.07.25.24.25.15,0,.22-.1.25-.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "6.49 .05 9.77 .05 9.77 3.39 9.17 3.39 9.16 .65 6.49 .65 6.49 .05",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.35 .69 .61 .69 .61 3.37 0 3.37 0 .09 3.35 .08 3.35 .69",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.17 6.33 9.78 6.33 9.78 9.61 6.44 9.61 6.44 9 9.17 9 9.17 6.33",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: ".35 6.3 .35 9.35 3.32 9.35",
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 7.5,
    strokeWidth: ".38px"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYantroppernewOptimized);
export default __webpack_public_path__ + "static/media/yantroppernew_optimized.c17e9f7082351cf5a644367fd06fae25.svg";
export { ForwardRef as ReactComponent };